import { StyleSheet, css } from "aphrodite";

import Image from "~/components/Image";

import { COLORS } from "~/config/themes";

const VerifiedBadge = ({ badgeStyles, iconAlt, iconSrc, text }) => {
  return (
    <div className={css(styles.badgeContainer, badgeStyles)}>
      <Image className={css(styles.icon)} alt={iconAlt} imageSrc={iconSrc} />
      <span>{text}</span>
    </div>
  );
};

const styles = StyleSheet.create({
  badgeContainer: {
    border: "1px solid #94A3B8",
    borderRadius: 40,
    width: 198,
    padding: "8px",
    fontSize: 14,
    fontWeight: 500,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    marginRight: 6,
  },
});

export default VerifiedBadge;
